import { useState } from 'react';
import { toast } from 'sonner';
import { auditoriaProveedoresApi } from '../../../lib/api';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';

export const IgnorarDialog = ({ open, onOpenChange, id, descripcion, onDone }) => {
  const [motivo, setMotivo] = useState('');
  const [busy, setBusy] = useState(false);

  const confirmar = async () => {
    setBusy(true);
    try {
      await auditoriaProveedoresApi.ignorar(id, motivo);
      toast.success('Discrepancia ignorada');
      onOpenChange(false);
      onDone();
    } catch (e) {
      toast.error('No se pudo ignorar', { description: e.response?.data?.detail || e.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="ignorar-dialog">
        <DialogHeader>
          <DialogTitle>Ignorar discrepancia</DialogTitle>
          <DialogDescription>{descripcion}. No volverá a aparecer como pendiente (puedes reabrirla desde el historial).</DialogDescription>
        </DialogHeader>
        <Input value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Motivo (opcional), ej: nombre de fantasía acordado con el proveedor" data-testid="ignorar-motivo" />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={busy}>Cancelar</Button>
          <Button onClick={confirmar} disabled={busy} data-testid="ignorar-confirmar">Ignorar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
